const CRAWLER_UA =
  /Googlebot|Google-InspectionTool|Storebot-Google|bingbot|BingPreview|Slurp|DuckDuckBot|Yandex|Baiduspider|facebookexternalhit|LinkedInBot|Twitterbot|Applebot|Bytespider/i;

export function isSearchCrawler(ua: string = typeof navigator !== 'undefined' ? navigator.userAgent : ''): boolean {
  return CRAWLER_UA.test(ua);
}

export function markSearchCrawler(): void {
  if (typeof document === 'undefined' || !isSearchCrawler()) return;
  document.documentElement.classList.add('is-crawler');
}
